<template>
    <div class="center-page">
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="全部" name="0"></el-tab-pane>
            <el-tab-pane label="通过审核" name="1"></el-tab-pane>
            <el-tab-pane label="审核中" name="2"></el-tab-pane>
            <el-tab-pane label="审核未通过" name="3"></el-tab-pane>
            <el-tab-pane label="上架中" name="4"></el-tab-pane>
            <el-tab-pane label="已下架" name="5"></el-tab-pane>
        </el-tabs>
        <div class="list-content" v-loading="loading">
            <div class="list-head">
                <div class="f-14 color-grays">共{{count}}个房源， {{count_release}}个房源发布中</div>
                <el-button type="primary" size="mini" @click="$router.push({path:'/center/addHouse'})">添加房源+</el-button>
            </div>
            <div class="list-item" v-for="(item,index) in list" :key="index">
                <img class="list-item-img" :src="`/api/v1/file/${item.cover}`" alt="">
                <div>
                    <div class="mb-10 item-title">
                        <div class="f-16 fw-b ">{{item.title}}</div>
                    </div>
                    <div class="f-14 color-grays"><i class="el-icon-location"></i> {{item.address}}</div>
                    <div class="btn-content">
                        <el-button type="success" size="mini" @click="calendarShow(item)">日历管理</el-button>
                        <el-button v-if="item.state===0" type="warning" @click="houseDelect(item.id)" size="mini">下架</el-button>
                        <el-button v-if="item.state===1" type="success" @click="houseDelect(item.id)" size="mini">上架</el-button>
                        <el-button type="warning" size="mini" @click="toEdit(item)">编辑</el-button>
                        <!--<el-button type="danger" size="mini">删除</el-button>-->
                    </div>
                </div>
                <div class="f-16 ml-a mr-a">房源价格：<span class="color-red f-22">{{+item.price|parseMoney}}</span></div>
                <div class="f-14 color-red">{{getStatus(item)}}</div>
            </div>
            <el-alert v-if="list.length<=0" title="暂无数据~" center :closable="false" type="warning" show-icon></el-alert>
        </div>

        <el-dialog :visible.sync="showCalendar" title="日历管理" width="550px">
            <el-form label-width="120px" label-position="right">
                <el-form-item label="导入日历：">
                    <el-input style="width: 240px;"></el-input>
                </el-form-item>
                <el-form-item label="导出日历：">
                    <el-link type="primary" :underline="false" @click="handleExportCalendar">导出</el-link>
                </el-form-item>
                <el-form-item label="日历管理：">
                    <Calendar :type="0"
                              multiple
                              v-loading="cloading"
                              :item="calendarData"
                              ref="calendar"
                              @change="handleCalendarChange"
                              @select="handleCalendarSelect"></Calendar>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="engineDriverAddTourist">设为不可用</el-button>
                    <el-button type="success" @click="engineDriverDelsTourist">设为可用</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
    import Calendar from "../../components/Calendar";
    export default {
        name: "houseManage",
        components:{Calendar},
        data() {
            return {
                showCalendar: false,
                activeName: '0',
                list: [],
                count_release: 0,
                count: 0,
                loading: false,
                cloading: false,
                year: '',
                month: '',
                house_id: '',
                calendarData: {},
                selectCalendarData: []
            }
        },
        created() {
            this.houseManage();
        },
        methods: {
            handleClick() {
                this.houseManage();
            },
            async houseManage() {
                let params = {};
                params.state = -1;
                if (this.activeName === '0') {
                    params.check = 0;
                } else if (this.activeName > 0 && this.activeName <= 3) {
                    params.check = this.activeName
                } else if (this.activeName === '4') {
                    params.state = 0
                } else if (this.activeName === '5') {
                    params.state = 1
                }
                this.loading = true;
                let [e, data] = await this.$api.houseManageApi(params);
                this.loading = false;
                this.list = data.result.house;
                this.count_release = data.result.count_release;
                this.count = data.result.count;
            },
            getStatus(item) {
                if (item.check === 1) {
                    return '通过审核，发布中'
                } else if (item.check === 2) {
                    return '审核中'
                } else if (item.check === 3) {
                    return '审核未通过'
                }
            },
            toEdit(item) {
                this.$router.push({path: '/center/addHouse', query: {id: item.id}})
            },
            async houseDelect(house_id){
                let [e, data] = await this.$api.houseDelectApi({house_id})
                if(data.code === 200){
                    this.$message.success('操作成功');
                    this.houseManage();
                }else{
                    this.$message.success(data.error)
                }
            },
            async calendarShow(item){
                let now = new Date();
                this.year = now.getFullYear();
                this.month = now.getMonth() + 1;
                this.house_id = item.id
                this.showCalendar = true;
                this.landlordCalendar();
            },
            async landlordCalendar(){
                this.cloading = true;
                let [e, data] = await this.$api.landlordCalendarApi({
                    year: this.year,
                    month: this.month,
                    type: 1,
                    house_id: this.house_id
                })
                this.cloading = false;
                this.calendarData = data.result.arr;
            },
            handleCalendarChange({year, month}){
                this.year = year;
                this.month = month;
                this.landlordCalendar();
            },
            handleCalendarSelect(data){
                this.selectCalendarData = data
            },
            async engineDriverAddTourist(){
                let [e, data] = await this.$api.landlordCalendarEditApi({
                    time: this.selectCalendarData,
                    state: 2,
                    house_id: this.house_id
                })
                if(data.status){
                    this.$message.success('设置成功！');
                    this.$refs.calendar.clear();
                    this.landlordCalendar()
                }else {
                    this.$message.warning(data.msg)
                }
            },
            async engineDriverDelsTourist(){
                let {year, month, day} = this.selectCalendarData;
                let [e, data] = await this.$api.landlordCalendarEditApi({
                    time: this.selectCalendarData,
                    state: 1,
                    house_id: this.house_id
                })
                if(data.status){
                    this.$message.success('设置成功！');
                    this.$refs.calendar.clear();
                    this.landlordCalendar()
                }else {
                    this.$message.warning(data.msg)
                }
            },
            handleExportCalendar(){
                window.open(`/api/v1/derive?house_id=${this.house_id}`)
            }
        },
    }
</script>

<style scoped lang="less">
    .list-content {
        width: 100%;

        .list-head {
            width: 100%;
            height: 54px;
            border-bottom: 1px solid #e2e2e2;
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 10px;
        }

        .list-item {
            width: 100%;
            height: 140px;
            padding: 20px;
            box-sizing: border-box;
            border-bottom: 1px solid #e2e2e2;
            display: flex;
            justify-content: flex-start;
            align-items: center;

            .list-item-img {
                width: 100px;
                height: 100px;
                object-fit: cover;
                margin-right: 20px;
                border-radius: 8px;
            }

            .item-title {
                width: 100%;
                display: flex;
                justify-content: space-between;
                align-items: center;
            }

            .btn-content {
                margin-top: 10px;
            }
        }
    }
</style>
